export default function setLocalStorageItem(itemKey, itemValue) {
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(`${itemKey}`, JSON.stringify(itemValue));
    }
    catch(error) {
      console.error(error);
    }
  }
  else {
    console.error('window object not found; localStorage is unavailable');
  }
}
